import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import Page from '../../../page.jsx';
import paymentPropTypes from '../../../paymentPropTypes';
import partnerPropTypes from '../../../partnerPropTypes';
import userPropTypes from '../../../userPropTypes';
import { data as agreementDataPropTypes } from '../../../agreementPropTypes';
import formatOreToKroner from '../../../../lib/formatOreToKroner';
import formatAutoPayout from '../autoPayoutFormatter';

const PaidDetails = ({ agreement, partner, payment, user }) => {
    const freight =
        agreement.freight > 0
            ? ` (inkludert ${formatOreToKroner(agreement.freight)} i frakt)`
            : null;

    const autoPayoutBankAccount = formatAutoPayout(user.bankAccounts);

    const commonText = (
        <div className="r-pbl">
            <p>
                {partner.name} har betalt {formatOreToKroner(agreement.total)}
                {freight} til FINN.
            </p>
            <p>Du vil få pengene når {partner.name} får og godkjenner varen.</p>
            {autoPayoutBankAccount ? (
                <p>
                    Du vil motta pengene på denne kontoen{' '}
                    {autoPayoutBankAccount}.
                </p>
            ) : (
                <p>På hvilken bankkonto ønsker du å motta pengene?</p>
            )}
        </div>
    );

    return autoPayoutBankAccount ? (
        <Page heading="Send varen">
            {commonText}
            <div className="r-phl r-ptl">
                <Link to="/samtale" className="button fullwidth">
                    OK
                </Link>
            </div>
            <div className="r-phl r-ptl">
                <a
                    href={payment.data.addAccountNumberUrl}
                    className="button fullwidth"
                >
                    Endre bankkonto
                </a>
            </div>
        </Page>
    ) : (
        <Page heading="Send varen og oppgi bankkonto">
            {commonText}
            <div className="r-phl r-ptl">
                <a
                    href={payment.data.addAccountNumberUrl}
                    className="button primary fullwidth"
                >
                    Legg til bankkonto
                </a>
            </div>
        </Page>
    );
};

PaidDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentPropTypes.isRequired,
    user: userPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement.data,
        partner: state.partner,
        payment: state.payment,
        user: state.user,
    };
}

export default connect(mapStateToProps)(PaidDetails);



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/statusDetails/paidDetails.jsx